module.exports = __webpack_public_path__ + "img/main.09294b3d.png";